import { CompanyNodeEdge } from '../Company/constants';

export interface ExpenseNode {
  id?: string;
  head: string;
  companyId?: string | null;
  company?: CompanyNodeEdge;
}

export interface ExpenseError {
  head: string;
}

export const ExpenseObject: ExpenseNode = {
  head: '',
  companyId: null,
};

export const ExpenseErrorObject: ExpenseError = {
  head: '',
};

export interface ExpenseQueryVariable {
  companyId: string;
}

export interface ExpenseQueryResponse {
  data: {
    allExpenses: {
      edges: ExpenseEdges[];
    };
  };
}

export interface ExpenseEdges {
  cursor?: string;
  node: ExpenseNode;
}

export const ExpenseQuery = `
  query ExpenseList($companyId: ID!) {
    allExpenses(companyId: $companyId) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          head
        }
      }
    }
  }
`;

export interface AddExpenseVariables {
  input: {
    expense: ExpenseNode;
  };
}

export const ExpenseMutation = `
  mutation addExpense($input: CreateExpenseInput!) {
    createExpense(input: $input){
      newExpense {
        id
        head
      }
    }
  }
`;
